import React from "react";
import getLicense from "./../../assets/AdsBanners/buy_license.jpeg";
// import onlineClass from "./../../assets/AdsBanners/online-class.jpeg";
import trainerBanner from "./../../assets/AdsBanners/trainer-banner.jpeg";
import "./AdsComponent.css";
import AdsSlider from "./AdsSlider";

const slides = [
  {
    image: trainerBanner,
    link: "/driving-license-video-guide/personal-driving-instructor",
    alt: "hire Personal Driving Instructor online in Sri Lanka",
  },
  {
    image: getLicense,
    link: "https://wa.me/94712367846?text=මට%20මේ%20ගැන%20තව%20තොරතුරු%20අවශ්‍යයි.%0A%0AI%20want%20more%20information%20about%20this.%0A%0Aஇதைப்%20பற்றி%20மேலும்%20தகவல்%20வேண்டும்.",
    alt: "get Driving License with online Instructor in Sri Lanka",
  },
  {
    image: trainerBanner,
    link: "/driving-license-video-guide/personal-driving-instructor",
    alt: "hire Personal Driving Instructor online in Sri Lanka",
  },
  {
    image: getLicense,
    link: "https://wa.me/94712367846?text=මට%20මේ%20ගැන%20තව%20තොරතුරු%20අවශ්‍යයි.%0A%0AI%20want%20more%20information%20about%20this.%0A%0Aஇதைப்%20பற்றி%20மேலும்%20தகவல்%20வேண்டும்.",
    alt: "get Driving License with online Instructor in Sri Lanka",
  },
];

function AdsComponent() {
  return <AdsSlider/>;

  // return (
  //   <div className="container-fluid px-0 top-height-ads">
  //     <div
  //       id="responsiveSlideshow"
  //       className="carousel slide"
  //       data-bs-ride="carousel"
  //     >
  //       <div className="carousel-indicators">
  //         <button
  //           type="button"
  //           data-bs-target="#responsiveSlideshow"
  //           data-bs-slide-to="0"
  //           className="active"
  //         ></button>
  //         <button
  //           type="button"
  //           data-bs-target="#responsiveSlideshow"
  //           data-bs-slide-to="1"
  //         ></button>
  //       </div>

  //       <div className="carousel-inner">
  //         <div className="carousel-item active">
  //           <div className="slide-container">
  //             <div
  //               className="blur-background"
  //               style={{ backgroundImage: `url(${onlineClass})` }}
  //             ></div>

  //             <div className="foreground-tile">
  //               <a href="/driving-license-video-guide/online-class" className="tile-link">
  //                 <div className="image-wrapper">
  //                   <img
  //                     src={onlineClass}
  //                     className="tile-image"
  //                     alt="Online driving class"
  //                   />
  //                 </div>
  //               </a>
  //             </div>
  //           </div>
  //         </div>

  //         <div className="carousel-item">
  //           <div className="slide-container">
  //             <div
  //               className="blur-background"
  //               style={{ backgroundImage: `url(${trainerBanner})` }}
  //             ></div>

  //             <div className="foreground-tile">
  //               <a
  //                 href="/driving-license-video-guide/personal-driving-instructor"
  //                 className="tile-link"
  //               >
  //                 <div className="image-wrapper">
  //                   <img
  //                     src={trainerBanner}
  //                     className="tile-image"
  //                     alt="hire Personal Driving Instructor online in Sri Lanka"
  //                   />
  //                 </div>
  //               </a>
  //             </div>
  //           </div>
  //         </div>
  //       </div>

  //       <button
  //         className="carousel-control-prev"
  //         type="button"
  //         data-bs-target="#responsiveSlideshow"
  //         data-bs-slide="prev"
  //       >
  //         <span className="carousel-control-prev-icon"></span>
  //         <span className="visually-hidden">Previous</span>
  //       </button>
  //       <button
  //         className="carousel-control-next"
  //         type="button"
  //         data-bs-target="#responsiveSlideshow"
  //         data-bs-slide="next"
  //       >
  //         <span className="carousel-control-next-icon"></span>
  //         <span className="visually-hidden">Next</span>
  //       </button>
  //     </div>
  //   </div>
  // );
}

export default AdsComponent;
